<template>
  <div class="status-bar">
    <div class="status-bar-body flex-align" :class="[state]">
      <bcc-icon type="ic_successful" class="status-bar-icon" v-if="state === 'success'"></bcc-icon>
      <bcc-icon type="ic_Systemerror" class="status-bar-icon" v-if="state === 'error'"></bcc-icon>
      <bcc-icon type="ic_systemprompt" class="status-bar-icon" v-if="state === 'info' || state === 'warning'"></bcc-icon>
      <div class="status-bar-content" v-html="text"></div>
      <bcc-icon type="ic_delete_" class="status-bar-close" @click="$emit('close')"></bcc-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusBar",
  props: {
    state: {
      type: String,
      default() {
        // info error warning success
        return 'info'
      }
    },
    text: String
  }
}
</script>

<style scoped lang="scss">
.status-bar {
  /*padding: 20px 0;*/
  .status-bar-body {
    border: 1px solid;
    box-sizing: border-box;
    /*height: 40px;*/
    padding: 10px 0;
    border-radius: 4px;
    font-size: 14px;
    color: #505050;
    line-height: 18px;
    font-weight: 400;

    &.success {
      border-color: #8BE09C;
      background-color: #F7FFF9;

      .status-bar-icon {
        color: #6DC781;
      }
    }

    &.error {
      border-color: #F99B96;
      background-color: #FFF3F0;

      .status-bar-icon {
        color: #FA5A57;
      }
    }

    &.warning {
      border-color: #FFC573;
      background-color: #FFFBF0;

      .status-bar-icon {
        color: #FAAB4B;
      }
    }

    &.info {
      border-color: #55CBF2;
      background-color: #F7FBFF;

      .status-bar-icon {
        color: #00A1D6;
      }
    }

    .status-bar-icon {
      padding: 0 8px 0 16px;
    }

    .status-bar-content {
      flex: 1;
    }

    .status-bar-close {
      padding: 0 14px;
      font-size: 12px;
      color: #999999;
      cursor: pointer;
    }
  }
}
</style>
